import { render, staticRenderFns } from "./dashMedal.vue?vue&type=template&id=ba9ab206&scoped=true&"
import script from "./dashMedal.vue?vue&type=script&lang=js&"
export * from "./dashMedal.vue?vue&type=script&lang=js&"
import style0 from "./dashMedal.vue?vue&type=style&index=0&id=ba9ab206&lang=scss&rel=stylesheet%2Fsass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9ab206",
  null
  
)

export default component.exports